import { useEffect } from "react"
import { useVariables } from "../useVariables"
import { Routers } from "../../../../../../../constant/Routers"
import {
  SystemsManualDataSourceType,
  UseSystemsManualType,
} from "../../../../models/manual"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { GeneralCode } from "../../../../../../../constant/GeneralCode"

const { SCR920, SCR991_FAQ } = Routers
const { FAQ_TYPE_NOT_JICA_STAFF } = GeneralCode

export const useSystemsManual =
  (): UseSystemsManualType<SystemsManualDataSourceType> => {
    const {
      breadcrumbItems,
      columns,
      fileInfoList,
      getFiles,
      handleDownload,
      handlePreviewFile,
      isDisabledBtnDownload,
      isDisabledBtnPreview,
      isLoading,
      isLoadingLayout,
      isNotAccessScreen,
      isOpenPreviewFile,
      isRoleUser,
      isVisibleBtn,
      layoutTitle,
      onCancelPreviewFile,
      onChangePagination,
      onChangeTable,
      pathname,
      perItem,
      push,
      rowSelection,
      type,
    } = useVariables()

    // 「SCR920_ホーム画面」へ遷移する。
    const goToHome = () => {
      push(SCR920)
    }

    useEffect(() => {
      // ユーザの画面アクセス許可チェックを処理する。
      if (isNotAccessScreen) {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else {
        const _type =
          isRoleUser && pathname === SCR991_FAQ ? FAQ_TYPE_NOT_JICA_STAFF : type
        getFiles({ type: _type })
      }
    }, [])

    return {
      breadcrumbItems,
      columns,
      dataSource: fileInfoList,
      goToHome,
      handleDownload,
      handlePreviewFile,
      isDisabledBtnDownload,
      isDisabledBtnPreview,
      isLoading,
      isLoadingLayout,
      isOpenPreviewFile,
      isVisibleBtn,
      layoutTitle,
      onCancelPreviewFile,
      onChangePagination,
      onChangeTable,
      perItem,
      rowSelection,
    }
  }
